export default "__VITE_ASSET__2d27b470__"